import './index.css'
import * as React from 'react'
import Tooltip from 'components/ui/tooltip'

/**
 * A popover component that displays pricing-related description in a tooltip positioned at the bottom
 * @param children - React elements to wrap with the popover tooltip
 * @param description - Content to display in the popover tooltip
 * @param messageClassName - Optional CSS class name for the message container
 * @returns Wrapped children with tooltip that shows pricing description on hover
 */
class PricingPopover extends React.Component<{
  children: React.ReactNode
  description?: React.ReactNode
  messageClassName?: string
}> {
  render(): React.ReactElement<'div'> {
    const { messageClassName, description } = this.props
    return (
      <div className="pricing-popover">
        <Tooltip
          position="bottom"
          content={
            <div className={messageClassName ? messageClassName : ''}>
              {description}
            </div>
          }
        >
          {this.props.children}
        </Tooltip>
      </div>
    )
  }
}

export default PricingPopover
